import styled from "styled-components"

const ActionLinkedin = styled.a`
  cursor: pointer;
  align-items: center;
  padding: 0;
  margin: 0;
  span {
    display: block;
  }
`

export default ActionLinkedin
